import Vue from 'vue'
import Vuex from 'vuex'
import pathify from './pathify'
import {make} from 'vuex-pathify'
import createPersistedState from 'vuex-persistedstate'

const state = {
    token: null,
    decodedToken: null,
    userData: null,
    version: '0.1.0'
}

const getters = {}

const mutations = make.mutations(state)

Vue.use(Vuex)

export default new Vuex.Store({
    state,
    getters,
    mutations,
    plugins: [
        pathify.plugin,
        createPersistedState({key: "DALOUNNY", storage: window.localStorage}),
    ],
});